module.exports = __webpack_public_path__ + "static/team-members-d36c6d49fec2dd089fdcf08cbddb0121.jpg";